import React, { useState, useEffect } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { Button } from "@mui/material";

const GraficaItem = ({ grafica, setIDArtSta }) => {
  // RECUPERO VARIABILI GLOBALI (Uso window.global per sicurezza)
  const appGlobal = window.global || global || {};
  const baseUrl = appGlobal.baseUrlImage || "";
  const placeholder = appGlobal.placeholderImage || "";

  // 1. Determina l'URL di base iniziale
  // Controllo extra: aggiungiamo lo slash se manca tra base e nome file
  let imagePath = grafica.image && grafica.image.length > 0 ? grafica.image[0] : null;

  let originalUrl = placeholder;
  if (imagePath) {
    // Gestione slash per evitare "http://sito.comimg.png"
    if (baseUrl.endsWith("/") && imagePath.startsWith("/")) {
      originalUrl = baseUrl + imagePath.substring(1);
    } else if (!baseUrl.endsWith("/") && !imagePath.startsWith("/")) {
      originalUrl = baseUrl + "/" + imagePath;
    } else {
      originalUrl = baseUrl + imagePath;
    }
  }

  const [bgImage, setBgImage] = useState(placeholder);

  useEffect(() => {
    let isMounted = true;

    const checkImage = (src, isRetry = false) => {
      // DEBUG: Decommenta se vuoi vedere i tentativi in console
      // console.log("Tentativo caricamento:", src);

      const img = new Image();
      img.src = src;

      img.onload = () => {
        if (isMounted) {
          // console.log("Caricato con successo:", src);
          setBgImage(src);
        }
      };

      img.onerror = () => {
        // console.warn("Errore caricamento:", src);
        if (isMounted && !isRetry) {
          let alternativeUrl = src;

          // Logica di swap estensione
          if (src.toLowerCase().includes(".png")) {
            alternativeUrl = src.replace(/.png/gi, ".jpg");
          } else if (src.toLowerCase().includes(".jpg")) {
            alternativeUrl = src.replace(/.jpg/gi, ".png");
          } else if (src.toLowerCase().includes(".jpeg")) {
            alternativeUrl = src.replace(/.jpeg/gi, ".png");
          }

          // Se l'URL è cambiato, riproviamo
          if (alternativeUrl !== src) {
            checkImage(alternativeUrl, true);
          }
        }
      };
    };

    if (imagePath) {
      checkImage(originalUrl);
    } else {
      setBgImage(placeholder);
    }

    return () => {
      isMounted = false;
    };
  }, [originalUrl, placeholder, imagePath]); // Dipendenze aggiornate

  if (grafica.name === "") return null;

  return (
    <div
      className={
        "col-12 " + (appGlobal.aziendaID == 4 ? "col-md-4" : "col-md-2")
      }
      onClick={() => {
        setIDArtSta(grafica.id);
        sessionStorage.setItem("IDArtSta", grafica.id);
      }}
    >
      <div
        className="card text-center shadow-sm border-0"
        style={{ height: "200px" }}
      >
        <div
          className="card-body"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1)), url('${bgImage}')`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            alignItems: "center",
            justifyContent: "end",
            display: "flex",
            flexDirection: "column",
          }}
        >
        </div>
        <h3
          className="card-title"
          style={{ color: "black", textShadow: "0 0 5px #000" }}
        >
          {grafica.sku}
        </h3>
      </div>
    </div>
  );
};

// --- COMPONENTE PRINCIPALE ---
const ShopProductGrafiche = ({
  products,
  value,
  category,
  setIDArtSta,
}) => {
  // Filtri e Ordinamento
  products = products
    .filter((product) => product.category.includes("GRAFICHE"))
    .sort((a, b) => b.orderGrafica - a.orderGrafica);

  if (value) {
    products = products.filter((product) =>
      product.sku.toLowerCase().includes(value.toLowerCase())
    );
  }

  const history = useHistory();

  return (
    <div
      className={
        "row g-4 " + (global.aziendaID == 4 ? "justify-content-center" : "")
      }
    >
      {(global.aziendaID == 2 || (global.aziendaID == 4 && category)) && (
        <div>
          <Button onClick={() => history.goBack()}>
            <ArrowBackIcon />
          </Button>
        </div>
      )}

      {products?.map((grafica) => (
        <GraficaItem
          key={grafica.id}
          grafica={grafica}
          global={global} // Assicurati che 'global' sia accessibile qui
          setIDArtSta={setIDArtSta}
        />
      ))}
    </div>
  );
};

// --- ESPORTAZIONE (Questo risolve il tuo errore) ---
export default ShopProductGrafiche;